/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowCircleLeft = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 2c-4.412 0-8 3.59-8 8s3.588 8 8 8 8-3.59 8-8-3.588-8-8-8zm.293 2.293 1.414 1.414L10.414 11H17v2h-6.586l3.293 3.293-1.414 1.414L6.586 12z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrowCircleLeft as ArrowCircleLeft };
